import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Ingresos from '../views/Ingresos.vue'
import Egresos from '../views/Egresos.vue'
import Despachos from '../views/Despachos.vue'
import MovimientosInternos from '../views/MovimientosInternos.vue'
import Trazabilidad from '../views/Trazabilidad.vue'
import Inventario from '../views/Inventario.vue'
import Instalaciones from '../views/Instalaciones.vue'
import Analytics from '../views/Analytics.vue'
import CostManagement from '../views/CostManagement.vue'
import Orders from '../views/Orders.vue'
import Users from '../views/Users.vue'
import OperatorDashboard from '../views/OperatorDashboard.vue'
import OperatorStorageDashboard from '../views/OperatorStorageDashboard.vue'
import PickingAssignment from '../views/PickingAssignment.vue'
import ServiceAssignment from '../views/ServiceAssignment.vue'
import IntelligentPicking from '../views/IntelligentPicking.vue'
import StorageExecution from '../views/StorageExecution.vue'
import WavePicking from '../views/WavePicking.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    redirect: '/inventario'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/ingresos',
    name: 'Ingresos',
    component: Ingresos,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/egresos',
    name: 'Egresos',
    component: Egresos,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/despachos',
    name: 'Despachos',
    component: Despachos,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/movimientos-internos',
    name: 'MovimientosInternos',
    component: MovimientosInternos,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/trazabilidad',
    name: 'Trazabilidad',
    component: Trazabilidad,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'viewer'] }
  },
  {
    path: '/inventario',
    name: 'Inventario',
    component: Inventario,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator', 'viewer'] }
  },
  {
    path: '/instalaciones',
    name: 'Instalaciones',
    component: Instalaciones,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'viewer'] }
  },
  {
    path: '/cost-management',
    name: 'CostManagement',
    component: CostManagement,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'viewer'] }
  },
  {
    path: '/picking-assignment',
    name: 'PickingAssignment',
    component: PickingAssignment,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/service-assignment',
    name: 'ServiceAssignment',
    component: ServiceAssignment,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/intelligent-picking',
    name: 'IntelligentPicking',
    component: IntelligentPicking,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator'] }
  },
  {
    path: '/intelligent-picking/:id',
    name: 'IntelligentPickingExecution',
    component: IntelligentPicking,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator'] }
  },
  {
    path: '/storage-execution/:id',
    name: 'StorageExecution',
    component: StorageExecution,
    meta: { requiresAuth: true, allowedRoles: ['admin', 'operator'] }
  },
  {
    path: '/wave-picking',
    name: 'WavePicking',
    component: WavePicking,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true, allowedRoles: ['admin'] }
  },
  {
    path: '/operator',
    name: 'OperatorDashboard',
    component: OperatorDashboard,
    meta: { requiresAuth: true, allowedRoles: ['operator'] }
  },
  {
    path: '/operator-storage-dashboard',
    name: 'OperatorStorageDashboard',
    component: OperatorStorageDashboard,
    meta: { requiresAuth: true, allowedRoles: ['operator'] }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navegación guard para verificar autenticación y permisos
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = store.getters['auth/isAuthenticated']
  const currentUser = store.getters['auth/currentUser']
  
  if (requiresAuth && !isAuthenticated) {
    next('/login')
    return
  }
  
  if (to.path === '/login' && isAuthenticated) {
    // Redirigir según el rol del usuario
    if (currentUser?.role === 'operator') {
      next('/operator')
    } else {
      next('/inventario')
    }
    return
  }
  
  // Verificar permisos por rol
  const allowedRoles = to.meta.allowedRoles
  if (allowedRoles && currentUser && !allowedRoles.includes(currentUser.role)) {
    // Redirigir a la página apropiada según el rol
    if (currentUser.role === 'operator') {
      next('/operator')
    } else {
      next('/inventario')
    }
    return
  }
  
  next()
})

export default router
